import styled from "@emotion/styled";
import { fontRobotoCondensed } from "@product/scmp-sdk";

import { Swiper } from "~/components/swiper";

export const Container = styled.div``;

export const Header = styled.h2`
  padding-block: 16px;

  color: #001246;
  font-weight: 900;
  font-size: 16px;
  font-family: ${fontRobotoCondensed};
  line-height: 30px;
`;

export const StyledSwiper = styled(Swiper)`
  .swiper-pagination {
    padding-block: 16px;
  }
`;
